// docs: https://github.com/altostra/type-validations#readme
import { objectOf } from "@altostra/type-validations";
import { number, string } from "@altostra/type-validations/lib/primitives";

export const isEngagementUpdateFeatureFlagRolloutArchivedStateResult = objectOf({
  info: string,
  num_items_updated: number,
});
